import { render, staticRenderFns } from "./AccountDelegate.vue?vue&type=template&id=1c224b30&scoped=true"
import script from "./AccountDelegate.vue?vue&type=script&lang=js"
export * from "./AccountDelegate.vue?vue&type=script&lang=js"
import style0 from "./AccountDelegate.vue?vue&type=style&index=0&id=1c224b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c224b30",
  null
  
)

export default component.exports